import React from "react";
import PropTypes from "prop-types";
import { CenteredElement, TitleStyled } from "../Titles.styles";
import { STYLES } from "../../../../styles/_utilities";

const Title = ({
  justifyContent,
  marginBottom,
  marginLeft,
  marginTop,
  marginRight,
  marginBottomMobile,
  marginLeftMobile,
  marginTopMobile,
  marginRightMobile,
  children,
  textFontSize,
  textFontSizeMobile,
  textFontColor,
  textLineHeight,
  textLineHeightMobile,
  textFontWeight,
}) => {
  return (
    <CenteredElement justifyContent={justifyContent}>
      <TitleStyled
        textFontColor={textFontColor}
        textFontWeight={textFontWeight}
        textFontSize={textFontSize}
        textFontSizeMobile={textFontSizeMobile}
        textLineHeight={textLineHeight}
        textLineHeightMobile={textLineHeightMobile}
        marginLeft={marginLeft}
        marginLeftMobile={marginLeftMobile}
        marginBottom={marginBottom}
        marginBottomMobile={marginBottomMobile}
        marginRight={marginRight}
        marginRightMobile={marginRightMobile}
        marginTop={marginTop}
        marginTopMobile={marginTopMobile}
      >
        {children}
      </TitleStyled>
    </CenteredElement>
  );
};

Title.propTypes = {
  children: PropTypes.node.isRequired,
  justifyContent: PropTypes.string,
  marginBottom: PropTypes.string,
  marginLeft: PropTypes.string,
  marginRight: PropTypes.string,
  marginTop: PropTypes.string,
  marginBottomMobile: PropTypes.string,
  marginLeftMobile: PropTypes.string,
  marginRightMobile: PropTypes.string,
  marginTopMobile: PropTypes.string,
  textFontSize: PropTypes.number,
  textFontSizeMobile: PropTypes.number,
  textFontColor: PropTypes.string,
  textLineHeight: PropTypes.number,
  textLineHeightMobile: PropTypes.number,
  textFontWeight: PropTypes.number,
};

Title.defaultProps = {
  justifyContent: STYLES.contentFlexStart,
  textFontColor: "#d52b1e",
  textFontWeight: 500,
  marginTop: undefined,
  marginTopMobile: undefined,
  marginBottom: undefined,
  marginBottomMobile: undefined,
  marginLeft: undefined,
  marginLeftMobile: undefined,
  marginRight: undefined,
  marginRightMobile: undefined,
  textFontSize: 35,
  textFontSizeMobile: 25,
  textLineHeight: 35,
  textLineHeightMobile: 25,
};

export default Title;
